import React from "react";
import { useField } from "formik";
import { Form, Col } from "react-bootstrap";

const BTextField = ({ as, md, controlId, label, size, type, ...props }) => {
    const [field, meta] = useField(props);
    
    // const cancelPasting = (e) => {
    //     if (type === 'password') {
    //         e.preventDefault()
    //     }
    // }

    return (
        <Form.Group as={as} md={md} controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...field}
                {...props}
                size={size}
                type={type}
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                // onPaste={(e) => cancelPasting(e)}
            />
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BTextField.defaultProps = {
    as: Col,
    md: 6,
    size: "md",
    type: "text",
    maxLength: 255
};

export default BTextField;
